export const RETROFIT_BUILDING_TYPE = {
    SCHOOL: "school",
    DAYCARE: "daycare",
    ADMINISTRATIVE_BUILDING: "administrativeBuilding",
    SPORTS_HALL: "sportsHall",
};
